import { render, staticRenderFns } from "./BetaPromotion.vue?vue&type=template&id=14d83c50&scoped=true&"
import script from "./BetaPromotion.vue?vue&type=script&lang=js&"
export * from "./BetaPromotion.vue?vue&type=script&lang=js&"
import style0 from "./BetaPromotion.vue?vue&type=style&index=0&id=14d83c50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d83c50",
  null
  
)

export default component.exports